import { render } from "./sql-chapter-1.vue?vue&type=template&id=0cadadfb"
import script from "./sql-chapter-1.vue?vue&type=script&lang=js"
export * from "./sql-chapter-1.vue?vue&type=script&lang=js"

import "./sql-chapter-1.vue?vue&type=style&index=0&id=0cadadfb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__